// Auto-generated from the bedd.dev BIMAssess homepage snapshot
// (Wayback Machine capture of https://bimassess.bedd.dev/, 2026-05-21).
// CTAs rewired to SPA routes; subpage links open the live bedd.dev origin in a new tab.
// Re-running the rewire script regenerates this file; edit landing.tsx, not here.

export const landingMarkup = `<nav class="site-nav">
  <div class="nav-inner">
    <a href="/" data-spa-link class="nav-logo">BIMAssess</a>
    <ul class="nav-links">
      <li><a href="/individual">For Individual</a></li>
      <li><a href="/business">For Business</a></li>
      <li><a href="/catalogue">Catalogue</a></li>
      <li><a href="/pricing">Pricing</a></li>
    </ul>
    <div class="nav-cta-group">
      <a href="/sign-in" data-spa-link class="login">Sign in</a>
      <a href="/sign-up" data-spa-link class="btn btn-primary">Get started</a>
    </div>
  </div>
</nav>

<!-- ──────────────────────────────────────────────
     HERO
─────────────────────────────────────────────── -->
<section class="hero">
  <div class="container">
    <div class="hero-grid">
      <div class="hero-copy">
        <div class="eyebrow hero-eyebrow-anim">Revit Assessment · Built by practitioners</div>
        <h1>
          <span class="word">The</span>
          <span class="word">benchmark</span>
          <span class="word">for</span>
          <span class="word accent">BIM</span>
          <span class="word accent">professionals.</span>
        </h1>
        <p class="lede">
          Eighteen assessments across four tracks—aligned to Autodesk ACU and ACP.
          <strong>Know where you stand. Prove what you can do.</strong>
        </p>
        <div class="hero-actions">
          <a href="/sign-up" data-spa-link class="btn btn-primary btn-magnetic">Start free assessment →</a>
          <a href="#catalogue" class="btn btn-ghost">Browse catalogue</a>
        </div>
      </div>

      <div class="hero-mockup">
        <!-- Simplified main card -->
        <div class="mockup-card mockup-main">
          <div class="mockup-header">
            <div class="mockup-title-block">
              <div class="label">Your Benchmark</div>
              <div class="title">Architecture Track</div>
            </div>
            <div class="mockup-status">Verified</div>
          </div>

          <div class="skill-row">
            <div class="skill-name">Novice</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 100%"></div></div>
            <div class="skill-score">100</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Foundation</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 92%"></div></div>
            <div class="skill-score">92</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Intermediate</div>
            <div class="skill-bar"><div class="skill-fill acc" style="--w: 78%"></div></div>
            <div class="skill-score">78</div>
          </div>
          <div class="skill-row">
            <div class="skill-name" style="color:var(--muted-2)">Advanced</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 0%"></div></div>
            <div class="skill-score">—</div>
          </div>
          <div class="skill-row">
            <div class="skill-name" style="color:var(--muted-2)">BIM Champion</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 0%"></div></div>
            <div class="skill-score">—</div>
          </div>

          <div class="mockup-footer">
            <span><span class="dot"></span>Aligned to Autodesk ACP</span>
            <span>3 of 5 levels</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     MARQUEE STRIP
─────────────────────────────────────────────── -->
<div class="marquee">
  <div class="marquee-track">
    <span class="marquee-item">Architecture · Novice</span>
    <span class="marquee-item">Family Creation</span>
    <span class="marquee-item">MEP · Specialist</span>
    <span class="marquee-item">Structural · Advanced</span>
    <span class="marquee-item">Interior Design</span>
    <span class="marquee-item">BIM Champion</span>
    <span class="marquee-item">ACP Preparation</span>
    <span class="marquee-item">Identify skill gaps</span>
    <span class="marquee-item">Benchmark your team</span>
    <span class="marquee-item">Hire with confidence</span>
    <!-- duplicate for seamless loop -->
    <span class="marquee-item">Architecture · Novice</span>
    <span class="marquee-item">Family Creation</span>
    <span class="marquee-item">MEP · Specialist</span>
    <span class="marquee-item">Structural · Advanced</span>
    <span class="marquee-item">Interior Design</span>
    <span class="marquee-item">BIM Champion</span>
    <span class="marquee-item">ACP Preparation</span>
    <span class="marquee-item">Identify skill gaps</span>
    <span class="marquee-item">Benchmark your team</span>
    <span class="marquee-item">Hire with confidence</span>
  </div>
</div>

<!-- ──────────────────────────────────────────────
     WHO IT'S FOR — 2 cards, black bg
─────────────────────────────────────────────── -->
<section class="section section-warm">
  <div class="container">
   

    <div class="audience-grid reveal-stagger">
      <a href="/individual" class="audience-card">
        <div class="audience-tag">For Individual</div>
        <h3>Stop guessing.<br>Start proving.</h3>
        <p>Benchmark your Revit skills against industry standards. Find out exactly where you stand—then close the gaps with focused practice. Walk into your next role with proof, not promises.</p>
        <div class="audience-meta">
          <span>Personal · Verified credential · ACP prep</span>
        </div>
        <div class="audience-cta">Explore for individuals <span class="arrow">→</span></div>
      </a>

      <a href="/business" class="audience-card">
        <div class="audience-tag">For Business</div>
        <h3>Know your team.<br>Hire with confidence.</h3>
        <p>Spot Revit skill gaps before they become project risk. Screen candidates with verified competency, not CV claims. Build training plans grounded in real data—not guesswork.</p>
        <div class="audience-meta">
          <span>Teams · Recruitment · Custom assessments</span>
        </div>
        <div class="audience-cta">Explore for business <span class="arrow">→</span></div>
      </a>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     WHY BIMASSESS
─────────────────────────────────────────────── -->
<section class="section section-warm">
  <div class="container">
    <span class="section-anchor">03 / Why us</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">By BIM professionals, for BIM professionals</div>
        <h2>The benchmark, built<br>from the <span class="accent">inside.</span></h2>
      </div>
      <div class="rhs">
        Every assessment is Revit-task based—not multiple-choice trivia. Built by practitioners who've delivered real projects and know exactly where professionals struggle.
      </div>
    </div>

    <div class="why-grid reveal-stagger">
      <div class="why-card">
        <div class="why-visual">
          <div class="vis-practitioner">
            <div class="check-stack">
              <div class="check-row">
                <svg viewBox="0 0 12 12" fill="none"><path d="M3 6l2 2 4-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Real project workflows
              </div>
              <div class="check-row">
                <svg viewBox="0 0 12 12" fill="none"><path d="M3 6l2 2 4-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Industry pain points
              </div>
              <div class="check-row">
                <svg viewBox="0 0 12 12" fill="none"><path d="M3 6l2 2 4-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Practitioner-reviewed
              </div>
              <div class="check-row muted">
                <svg viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="3" stroke="currentColor" stroke-width="1.4"/></svg>
                Generic theory tests
              </div>
            </div>
          </div>
        </div>
        <h3>Real Revit tasks.</h3>
        <p>Every question is a hands-on Revit scenario reviewed by practising BIM professionals—not theoretical multiple-choice. You're tested on what you actually do at work.</p>
      </div>

      <div class="why-card">
        <div class="why-visual">
          <div class="vis-standards">
            <div class="std-card">
              <div class="lbl">ISO</div>
              <div class="val">19650</div>
            </div>
            <div class="std-card acc">
              <div class="lbl">Autodesk</div>
              <div class="val">ACU + ACP</div>
            </div>
            <div class="std-card">
              <div class="lbl">UK BIM</div>
              <div class="val">Framework</div>
            </div>
          </div>
        </div>
        <h3>Aligned to industry standards.</h3>
        <p>Mapped to Autodesk ACU and ACP. Aligned with ISO 19650 and the UK BIM Framework. Recognized by employers who hire BIM talent.</p>
      </div>

      <div class="why-card">
        <div class="why-visual">
          <div class="vis-cert">
            <div class="cert-card">
              <div class="cert-head">
                <span>BIMAssess</span>
                <span>VERIFIED</span>
              </div>
              <div class="cert-name">Architecture · Advanced</div>
              <div class="cert-score">87 / 100 · ARCH-07</div>
            </div>
            <div class="cert-stamp">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M5 9l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
        <h3>Verifiable, sharable proof.</h3>
        <p>Every certified result comes with a verifiable digital credential. Share it with employers, on LinkedIn, in your portfolio.</p>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     MID-PAGE BLACK CTA — CVs and interviews
─────────────────────────────────────────────── -->
<section class="mid-cta">
  <div class="container">
    <div class="mid-cta-grid reveal">
      <h2 class="mid-cta-headline">CVs and interviews don't distinguish<br>real talent <span class="accent">from AI.</span></h2>
      <div class="mid-cta-body">
        <p>Proven skills require industry-focused benchmarking. By testing and certifying, we empower professionals to grow, help companies uncover skill gaps, and enable confident hiring.</p>
        <div class="mid-cta-actions">
          <a href="/sign-up" data-spa-link class="btn btn-primary btn-magnetic">Try for free →</a>
          <a href="#catalogue" class="btn btn-ghost-light">See catalogue</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     CATALOGUE PREVIEW
─────────────────────────────────────────────── -->
<section class="section" id="catalogue">
  <div class="container">
    <span class="section-anchor">05 / Catalogue</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">Exam catalogue</div>
        <h2>Eighteen assessments.<br><span class="accent">Four tracks.</span></h2>
      </div>
      <div class="rhs">
        From your first steps in Revit to BIM Champion-level mastery—every exam reflects real industry expectations, not textbook theory.
        <div style="margin-top:1rem;"><a href="/catalogue" class="btn-link">View full catalogue →</a></div>
      </div>
    </div>

    <div class="tab-toggle reveal" style="margin-bottom: 2rem;">
      <button class="tab-btn active" data-tab="individual">For Individual</button>
      <button class="tab-btn" data-tab="business">For Business</button>
    </div>

    <div class="exam-grid reveal-stagger">
      <div class="exam-pill">
        <div class="ep-track">Architecture</div>
        <div class="ep-name">Novice</div>
        <div class="ep-meta"><span>ARCH-01</span><span class="ep-price">$29</span></div>
      </div>
      <div class="exam-pill">
        <div class="ep-track">Architecture</div>
        <div class="ep-name">Family Creation</div>
        <div class="ep-meta"><span>ARCH-03</span><span class="ep-price">$29</span></div>
      </div>
      <div class="exam-pill">
        <div class="ep-track">Architecture</div>
        <div class="ep-name">Advanced</div>
        <div class="ep-meta"><span>ARCH-07</span><span class="ep-price">$29</span></div>
      </div>
      <div class="exam-pill exam-pill-acc">
        <div class="ep-track">Architecture</div>
        <div class="ep-name">BIM Champion</div>
        <div class="ep-meta"><span>ARCH-08</span><span class="ep-price">$49</span></div>
      </div>
      <div class="exam-pill">
        <div class="ep-track">Discipline</div>
        <div class="ep-name">Mechanical Specialist</div>
        <div class="ep-meta"><span>MEC-02</span><span class="ep-price">$29</span></div>
      </div>
      <div class="exam-pill">
        <div class="ep-track">Discipline</div>
        <div class="ep-name">Structural Advanced</div>
        <div class="ep-meta"><span>STR-03</span><span class="ep-price">$29</span></div>
      </div>
      <div class="exam-pill">
        <div class="ep-track">Discipline</div>
        <div class="ep-name">Interior Design</div>
        <div class="ep-meta"><span>INT-02</span><span class="ep-price">$29</span></div>
      </div>
      <div class="exam-pill">
        <div class="ep-track">ACP Prep</div>
        <div class="ep-name">Certified Professional</div>
        <div class="ep-meta"><span>ACP-01</span><span class="ep-price">$49</span></div>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     CERTIFICATE + BADGE PREVIEW (new)
─────────────────────────────────────────────── -->
<section class="section section-warm">
  <div class="container">
    <span class="section-anchor">06 / Credential</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">Verified credentials</div>
        <h2>One certificate.<br><span class="accent">Every conversation.</span></h2>
      </div>
      <div class="rhs">
        Each passing score earns you a verifiable digital certificate and a shareable badge. Add it to LinkedIn. Embed it in your portfolio. Send the verification link to recruiters.
      </div>
    </div>

    <div class="credential-stage reveal">
      <div class="cred-cert">
        <div class="cred-cert-head">
          <div class="cred-cert-brand">BIMAssess</div>
          <div class="cred-cert-verify">VERIFIED · ARCH-07</div>
        </div>
        <div class="cred-cert-body">
          <div class="cred-cert-label">Awarded to</div>
          <div class="cred-cert-name">Aisha Nakamura</div>
          <div class="cred-cert-meta">
            <div>
              <div class="cred-cert-label">Assessment</div>
              <div class="cred-cert-val">Architecture · Advanced</div>
            </div>
            <div>
              <div class="cred-cert-label">Score</div>
              <div class="cred-cert-val cred-score">87 / 100</div>
            </div>
            <div>
              <div class="cred-cert-label">Date</div>
              <div class="cred-cert-val">12 Mar 2026</div>
            </div>
          </div>
        </div>
        <div class="cred-cert-footer">
          <div class="cred-cert-label">Verify at bimassess.com/v/A7K-9MX2</div>
          <div class="cred-cert-aligned">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2 2 4-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Aligned to Autodesk ACU + ACP
          </div>
        </div>
      </div>

      <div class="cred-badge">
        <div class="cred-badge-ring">
          <div class="cred-badge-inner">
            <div class="cred-badge-label">BIMAssess</div>
            <div class="cred-badge-score">87</div>
            <div class="cred-badge-tier">Advanced</div>
          </div>
        </div>
        <div class="cred-badge-caption">Shareable badge<br>for LinkedIn, email, portfolio</div>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     PRICING
─────────────────────────────────────────────── -->
<section class="section" id="pricing">
  <div class="container">
    <span class="section-anchor">07 / Pricing</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">Pricing</div>
        <h2>Simple plans.<br><span class="accent">No surprises.</span></h2>
      </div>
      <div class="rhs">
        Pay per assessment, bundle a full track, or scale to your whole team. Every plan includes verified credentials and detailed score reports.
      </div>
    </div>

    <div class="reveal" style="display:flex; justify-content:center; margin-bottom: 2.5rem;">
      <div class="tab-toggle">
        <button class="tab-btn active" data-pricing-tab="individual">For Individual</button>
        <button class="tab-btn" data-pricing-tab="business">For Business</button>
      </div>
    </div>

    <!-- Individual plans -->
    <div class="price-grid reveal-stagger" id="pricing-individual">
      <div class="price-card">
        <div class="price-tag">Single Exam</div>
        <h3>Any Exam,<br>Any Discipline</h3>
        <div class="price-sub">One attempt at any assessment from the full catalogue.</div>
        <div class="price-amount">
          <span class="num">$39</span>
          <span class="per">/ attempt</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>One attempt at any exam</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Instant results + topic breakdown</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Verifiable certificate on pass</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Valid for 30 days from purchase</li>
        </ul>
        <a href="/pricing" class="btn btn-ghost">Browse exams</a>
      </div>

      <div class="price-card featured">
        <div class="price-tag">Most popular</div>
        <h3>Full Architecture<br>Pathway</h3>
        <div class="price-sub">All 8 Architecture exams. Unlimited retakes for 12 months.</div>
        <div class="price-amount">
          <span class="num">$139</span>
          <span class="per">/ 12 months</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>All 8 Architecture exams</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Unlimited retakes per exam</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Progress tracked across all levels</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Certificate on pass for each level</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Save 55% vs individual</li>
        </ul>
        <a href="/sign-up" data-spa-link class="btn btn-primary">Get the pack</a>
      </div>

      <div class="price-card">
        <div class="price-tag">Discipline Pack</div>
        <h3>Any Single<br>Discipline</h3>
        <div class="price-sub">Novice + Specialist for any one discipline. Unlimited retakes.</div>
        <div class="price-amount">
          <span class="num">$69</span>
          <span class="per">/ 12 months</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Choose one discipline</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Novice + Specialist exams included</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Unlimited retakes per exam</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Certificate on pass</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Save 12% vs individual</li>
        </ul>
        <a href="/pricing" class="btn btn-ghost">Choose discipline</a>
      </div>
    </div>

    <!-- Business plans -->
    <div class="price-grid" id="pricing-business" style="display:none;">
      <div class="price-card">
        <div class="price-tag">Small Practice</div>
        <h3>Starter</h3>
        <div class="price-sub">25 exam attempts per year for your team.</div>
        <div class="price-amount">
          <span class="num">$499</span>
          <span class="per">/ year</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>25 attempts per year</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Choose any exams from full catalogue</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Team skills report</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Individual result dashboards</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Admin account management</li>
        </ul>
        <a href="/business" class="btn btn-ghost">Get started</a>
      </div>

      <div class="price-card featured">
        <div class="price-tag">Most popular</div>
        <h3>Professional</h3>
        <div class="price-sub">60 exam attempts per year with candidate screening tools.</div>
        <div class="price-amount">
          <span class="num">$999</span>
          <span class="per">/ year</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>60 attempts per year</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Candidate screening mode</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Team skills report + gap analysis</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Individual result dashboards</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Priority email support</li>
        </ul>
        <a href="/business" class="btn btn-primary">Get started</a>
      </div>

      <div class="price-card">
        <div class="price-tag">Business</div>
        <h3>Unlimited</h3>
        <div class="price-sub">Unlimited attempts, custom branding, and dedicated support.</div>
        <div class="price-amount">
          <span class="num">$1,799</span>
          <span class="per">/ year</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Unlimited attempts</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Custom exam branding</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Candidate screening mode</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Dedicated account support</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Quarterly benchmark reports</li>
        </ul>
        <a href="/business" class="btn btn-ghost">Contact us</a>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     TESTIMONIALS
─────────────────────────────────────────────── -->
<section class="section section-warm">
  <div class="container">
    <span class="section-anchor">08 / Voices</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">Testimonials</div>
        <h2>Trusted by professionals<br>and the <span class="accent">teams that hire them.</span></h2>
      </div>
      <div class="rhs">
        From individual practitioners to BIM managers building stronger teams—real users, real results.
      </div>
    </div>

    <div class="testimonial-grid reveal-stagger">
      <div class="testimonial">
        <div class="testimonial-quote">
          "Finally, an assessment that mirrors what I actually do at work. Passing the Advanced exam got me a 30% raise—and a seat at the BIM coordination table."
        </div>
        <div class="testimonial-attr">
          <div class="testimonial-avatar">A</div>
          <div class="testimonial-meta">
            <div class="name">Aisha N.</div>
            <div class="role">BIM Coordinator · London</div>
          </div>
        </div>
      </div>

      <div class="testimonial">
        <div class="testimonial-quote">
          "We rolled it out across our 40-person Revit team. In six weeks we identified three critical skill gaps we didn't know existed—and trained around them."
        </div>
        <div class="testimonial-attr">
          <div class="testimonial-avatar">M</div>
          <div class="testimonial-meta">
            <div class="name">Marcus K.</div>
            <div class="role">BIM Manager · Singapore</div>
          </div>
        </div>
      </div>

      <div class="testimonial">
        <div class="testimonial-quote">
          "I shortlist BIM candidates faster now. A verified BIMAssess score tells me more in 30 seconds than a 3-page CV ever did."
        </div>
        <div class="testimonial-attr">
          <div class="testimonial-avatar">S</div>
          <div class="testimonial-meta">
            <div class="name">Sara L.</div>
            <div class="role">Technical Recruiter · Berlin</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     FAQ
─────────────────────────────────────────────── -->
<section class="section">
  <div class="container">
    <span class="section-anchor">09 / FAQ</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">FAQ</div>
        <h2>Quick answers,<br><span class="accent">before you ask.</span></h2>
      </div>
      <div class="rhs">
        Still have questions? <a href="#" style="color:var(--ink);font-weight:500;">Get in touch →</a>
      </div>
    </div>

    <div class="faq-wrap reveal">
      <details class="faq-item" open>
        <summary>What is BIMAssess?</summary>
        <p>BIMAssess is the benchmark for Revit and BIM competency. We offer 18 industry-aligned assessments across architecture, MEP, structural, and interior tracks—built by practising BIM professionals and aligned to Autodesk ACU and ACP standards.</p>
      </details>
      <details class="faq-item">
        <summary>How are assessments aligned to Autodesk standards?</summary>
        <p>Every BIMAssess exam is mapped against the published learning outcomes for Autodesk Certified User (ACU) and Autodesk Certified Professional (ACP) credentials. Our ACP Prep track is designed specifically as a pre-exam benchmark, so you can walk into the official Autodesk exam knowing where you stand.</p>
      </details>
      <details class="faq-item">
        <summary>How long does an assessment take?</summary>
        <p>Most assessments take 60–90 minutes. The ACP Prep is longer—around 2 hours—because it mirrors the structure of the real Autodesk exam. You can pause and resume at any time.</p>
      </details>
      <details class="faq-item">
        <summary>Can my team take assessments together?</summary>
        <p>Yes. The Business plan includes bulk seats, a team dashboard for managers, and aggregated skill-gap reporting. Contact us for pricing tailored to your team size.</p>
      </details>
      <details class="faq-item">
        <summary>Is the certificate recognized by employers?</summary>
        <p>BIMAssess credentials are recognized by employers across architecture, engineering, and construction—particularly those who already use Autodesk certifications as a hiring signal. Each certificate is verifiable via a unique URL and shareable on LinkedIn.</p>
      </details>
      <details class="faq-item">
        <summary>What's your refund policy?</summary>
        <p>If you haven't started an assessment, you can request a full refund within 14 days. The Professional plan includes a 7-day free trial, so you can explore the full catalogue before committing.</p>
      </details>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     FINAL CTA
─────────────────────────────────────────────── -->
<section class="final-cta">
  <div class="container">
    <h2>Ready to find out<br>where you <span style="color:#0139B7">stand?</span></h2>
    <p>Take your first assessment free. No card required. Get a verified result in 48 hours.</p>
    <div style="display:flex; gap:12px; justify-content:center; flex-wrap:wrap;">
      <a href="/sign-up" data-spa-link class="btn btn-primary btn-magnetic">Start free assessment →</a>
      <a href="/sign-up" data-spa-link class="btn btn-ghost">Book a team demo</a>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     FOOTER
─────────────────────────────────────────────── -->
<footer class="site-footer">
  <div class="container">
    <div class="footer-top">
      <div class="footer-brand-wrap">
        <div class="footer-brand">BIMAssess</div>
        <div class="footer-tag">The benchmark for BIM professionals. Built by BIM professionals, for BIM professionals. Aligned to Autodesk standards, trusted by the teams that hire.</div>
      </div>
      <div class="footer-col">
        <h5>Product</h5>
        <ul>
          <li><a href="/individual">For Individual</a></li>
          <li><a href="/business">For Business</a></li>
          <li><a href="/catalogue">Catalogue</a></li>
          <li><a href="/pricing">Pricing</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h5>Resources</h5>
        <ul>
          <li><a href="#">About</a></li>
          <li><a href="#">Blog</a></li>
          <li><a href="#">Help Center</a></li>
          <li><a href="#">Contact</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h5>Legal</h5>
        <ul>
          <li><a href="#">Privacy</a></li>
          <li><a href="#">Terms</a></li>
          <li><a href="#">Cookies</a></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© 2026 BIMAssess </span>
      <div class="footer-bottom-links">
        <a href="#">LinkedIn</a>
        <a href="#">X</a>
        <a href="#">Email</a>
      </div>
    </div>
  </div>
</footer>
`;
